import { render, staticRenderFns } from "./activiteConf.vue?vue&type=template&id=55debd8c&scoped=true&"
import script from "./activiteConf.vue?vue&type=script&lang=js&"
export * from "./activiteConf.vue?vue&type=script&lang=js&"
import style0 from "./activiteConf.vue?vue&type=style&index=0&id=55debd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55debd8c",
  null
  
)

export default component.exports